import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Subscription } from "rxjs";
import { CustomizerSettingsService } from '../../../customizer-settings/customizer-settings.service';
import { TemaService } from 'src/app/services/tema.services';
import {
    ChartComponent,
    ApexChart,
    ApexAxisChartSeries,
    ApexTitleSubtitle,
    ApexDataLabels,
    ApexGrid,
    ApexFill,
    ApexYAxis,
    ApexXAxis,
    ApexTooltip,
    ApexMarkers,
    ApexAnnotations,
    ApexStroke
} from "ng-apexcharts";

import { data } from "./series-data";

export type ChartOptions = {
    series: ApexAxisChartSeries;
    chart: ApexChart;
    dataLabels: ApexDataLabels;
    markers: ApexMarkers;
    title: ApexTitleSubtitle;
    fill: ApexFill;
    yaxis: ApexYAxis;
    grid: ApexGrid;
    xaxis: ApexXAxis;
    tooltip: ApexTooltip;
    stroke: ApexStroke;
    annotations: ApexAnnotations;
    colors: any;
    toolbar: any;
};

@Component({
    selector: 'app-market-graph',
    templateUrl: './market-graph.component.html',
    styleUrls: ['./market-graph.component.scss']
})
export class MarketGraphComponent implements OnInit, OnDestroy {

    @ViewChild("chart", { static: false }) chart: ChartComponent;
    public chartOptions: Partial<ChartOptions>;
    private isDark = false;
    private temaSub?: Subscription;

    constructor(
        public themeService: CustomizerSettingsService,
        private temaService: TemaService,
    ) {
        this.initChart();
    }

    ngOnInit(): void {
        this.temaSub = this.temaService.valDarkTheme.subscribe((dark: boolean) => {
            this.isDark = dark;
            this.applyThemeOptions();
        });
    }

    ngOnDestroy(): void {
        this.temaSub?.unsubscribe();
    }

    private themeColors() {
        return this.isDark
            ? {
                grid: 'rgba(255, 255, 255, 0.08)',
                labels: '#b2bfcc',
                tooltip: 'dark' as const,
            }
            : {
                grid: '#EDEFF5',
                labels: '#a9a9c8',
                tooltip: 'light' as const,
            };
    }

    private applyThemeOptions(): void {
        const c = this.themeColors();
        this.chart?.updateOptions({
            grid: { show: true, strokeDashArray: 5, borderColor: c.grid },
            xaxis: { labels: { style: { colors: c.labels, fontSize: "13px" } } },
            yaxis: { labels: { style: { colors: c.labels, fontSize: "13px" } } },
            tooltip: { theme: c.tooltip, x: { format: "dd MMM yyyy" } },
        }, false, true);
    }

    initChart(): void {
        const c = this.themeColors();
        this.chartOptions = {
            series: [
                {
                    name: "Price",
                    data: data
                }
            ],
            chart: {
                type: "area",
                height: 335,
                toolbar: {
                    show: false,
                }
            },
            dataLabels: {
                enabled: false
            },
            grid: {
                show: true,
                strokeDashArray: 5,
                borderColor: c.grid
            },
            colors: [
                "#4fc3f7"
            ],
            markers: {
                size: 0
            },
            xaxis: {
                type: "datetime",
                min: new Date("01 Mar 2012").getTime(),
                tickAmount: 6,
                labels: {
                    style: {
                        colors: c.labels,
                        fontSize: "13px",
                    },
                },
                axisBorder: {
                    show: false
                }
            },
            yaxis: {
                labels: {
                    style: {
                        colors: c.labels,
                        fontSize: "13px",
                    },
                },
            },
            tooltip: {
                theme: c.tooltip,
                x: {
                    format: "dd MMM yyyy"
                }
            }
        };
    }

    toggleTheme() {
        this.themeService.toggleTheme();
    }

    toggleRTLEnabledTheme() {
        this.themeService.toggleRTLEnabledTheme();
    }

}
